// REACT
import React from "react";
import { Link } from "react-router-dom";
import { compose, withProps, withStateHandlers } from "recompose";

// GOOGLE MAPS
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  InfoWindow,
  Marker,
} from "react-google-maps";
import MapStyle from "./mapStyle.json";

// STYLES
import styled from "styled-components";

// ICONS
import NetIconMembro from "../../assets/images/Icons Network/ic-badge-membro.svg";
import NetIconInscrito from "../../assets/images/Icons Network/ic-badge.inscrito.svg";

import IconMember from "../../assets/images/IconsMap/ic-marker-map-rede.svg";
import IconMe from "../../assets/images/IconsMap/ic-marker-map-rede-me.svg";
import IconConvidados from "../../assets/images/IconsMap/ic-marker-map-convidados.svg";
import IconInscritos from "../../assets/images/IconsMap/ic-marker-map-inscritos.svg";

const Maps = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyCUA1l3qBDleVNZRRu-fmTdPEkHLfoxmFM&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withStateHandlers(
    () => ({
      isOpen: false,
    }),
    {
      onToggleOpen:
        ({ isOpen }) =>
        () => ({
          isOpen: !isOpen,
        }),
    }
  ),
  withScriptjs,
  withGoogleMap
)((props) => {
  console.log("asljfojaposjfopajsfpoas");
  return (
    <GoogleMap
      defaultZoom={13}
      defaultCenter={{ lat: props.latitude, lng: props.longitude }}
      defaultOptions={{
        styles: MapStyle,
        scrollwheel: true,
        streetViewControl: false,
        scaleControl: true,
        mapTypeControl: false,
        panControl: true,
        zoomControl: true,
        rotateControl: false,
        fullscreenControl: true,
      }}
    >
      <Marker
        position={{
          lat: Number(props.pointerLat),
          lng: Number(props.pointerLng),
        }}
        //   onClick={() => props.getActive(marker.id)}
        icon={{ url: props.defineIcon(301) }}
      >
        {/* <InfoWindow onCloseClick={() => props.getActive(0)}>
          <InfoText>
            <img src={NetIconInscrito} alt="Inscrito" />
          </InfoText>
        </InfoWindow> */}
      </Marker>
      {props.data.map((marker, index) => {
        return (
          marker.coordinates.lat !== "" &&
          marker.coordinates.lon !== "" && (
            <Marker
              key={marker.id}
              defaultZIndex={props.defineIndex(marker.network)}
              position={{
                lat: Number(marker.coordinates.lat),
                lng: Number(marker.coordinates.lon),
              }}
              onClick={() => props.getActive(marker.id)}
              icon={{ url: props.defineIcon(marker.network) }}
            >
              {props.active === marker.id && (
                <InfoWindow onCloseClick={() => props.getActive(0)}>
                  <Link to={props.defineUrl(marker.slug)}>
                    <InfoText>
                      {marker.network === 1 && (
                        <img src={NetIconMembro} alt="Membro" />
                      )}
                      {marker.network === 2 && (
                        <img src={NetIconInscrito} alt="Inscrito" />
                      )}
                      {marker.name}
                    </InfoText>
                    <Country>{marker.country}</Country>
                  </Link>
                </InfoWindow>
              )}
            </Marker>
          )
        );
      })}
    </GoogleMap>
  );
});

export default class GoogleMaps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
    };
    this.getActive = this.getActive.bind(this);
    this.defineIcon = this.defineIcon.bind(this);
    this.defineIndex = this.defineIndex.bind(this);
    this.defineUrl = this.defineUrl.bind(this);
  }

  getActive(value) {
    this.setState({
      active: value,
    });
  }

  defineIcon(network) {
    if (network === 1) {
      return IconMember;
    } else if (network === 2) {
      return IconInscritos;
    } else if (network === 301) {
      return IconMe;
    } else {
      return IconConvidados;
    }
  }

  defineIndex(network) {
    if (network === 1) {
      return 1000;
    } else if (network === 2) {
      return 500;
    } else {
      return 200;
    }
  }

  defineUrl(slug) {
    const lang = this.props.i18n.language;
    if (lang === "pt") {
      return `/pt/restaurantes/${slug}`;
    } else if (lang === "en") {
      return `/en/restaurants/${slug}`;
    } else if (lang === "de") {
      return `/de/restaurants/${slug}`;
    } else if (lang === "es") {
      return `/es/restaurantes/${slug}`;
    } else if (lang === "fr") {
      return `/fr/restaurants/${slug}`;
    }
  }

  render() {
    return (
      <Maps
        data={this.props.data}
        pointerLat={localStorage.getItem("latitude")}
        pointerLng={localStorage.getItem("longitude")}
        active={this.state.active}
        getActive={this.getActive}
        defineIcon={this.defineIcon}
        defineIndex={this.defineIndex}
        defineUrl={this.defineUrl}
        latitude={parseFloat(localStorage.getItem("latitude"))}
        longitude={parseFloat(localStorage.getItem("longitude"))}
      />
    );
  }
}

const InfoText = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666666;
  font-weight: 600;

  img {
    margin-right: 5px;
  }
`;
const Country = styled.div`
  font-size: 12px;
  color: #666666;
  margin-top: 3px;
`;



// WEBPACK FOOTER //
// ./src/containers/GoogleMaps/googleMaps.container.js